import React, { useEffect, useContext } from "react";
import "../css/SplashScreen.css";
import { useNavigate } from "react-router-dom";
// import logo from "../assets/icons/logo.png";
import logo from "../assets/icons/dpboss.png";
import "../css/mainhome.css";
import { AppContext } from "../context/AppContext";

const SplashScreen = () => {
  const navigate = useNavigate();
  const { setUser } = useContext(AppContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const registerId = localStorage.getItem("registerId");
        const userProfile = localStorage.getItem("userProfile");
        const savedMobileNo =
          localStorage.getItem("mobileNo") ||
          localStorage.getItem("lastLoginMobileNo");

        if (accessToken && registerId) {
          if (userProfile && setUser) {
            try {
              setUser(JSON.parse(userProfile));
            } catch {
              localStorage.removeItem("userProfile");
            }
          }

          navigate("/login-with-mpin", { replace: true });
        } else if (savedMobileNo) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("registerId");
          localStorage.removeItem("userProfile");

          navigate("/login-with-mpin", { replace: true });
        } else {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("registerId");
          localStorage.removeItem("userProfile");

          navigate("/enter-mobile", { replace: true });
        }
      } catch {
        navigate("/enter-mobile", { replace: true });
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, setUser]);

  return (
    <div className="splash-wrapper">
      <div className="splash-logo-box">
        <img src={logo} alt="Logo" className="splash-logo" />
      </div>

      <div className="splash-arc-back"></div>
      <div className="splash-arc-mid"></div>
      <div className="splash-arc-front"></div>
    </div>
  );
};

export default SplashScreen;
